import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import getConfig from '../../Util/Config';

import ConfigContext from './context';

const ConfigProvider = ({ config: appConfig, children }) => {
  const [config, setConfig] = useState(appConfig ?? getConfig());
  useEffect(() => {
    if (appConfig) setConfig(appConfig);
  }, [appConfig]);
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

ConfigProvider.propTypes = {
  config: PropTypes.object,
};

export default ConfigProvider;
